import styled from 'styled-components';

import { AssignList } from '@components/assign-button';
import { Tooltip } from '@components/tooltip';

import { ActiveUser } from '../hooks/use-journey-presence';

type TooltipPlacement = 'top' | 'bottom' | 'left' | 'right';

type UserAvatarListProps = {
  users: ActiveUser[];
  maxVisible: number;
  tooltipPlacement?: TooltipPlacement;
};

export const UserAvatarList = ({
  users,
  maxVisible,
  tooltipPlacement = 'top',
}: UserAvatarListProps) => {
  if (users.length === 0) {
    return null;
  }

  const shouldShowOverflow = users.length > maxVisible;
  const visibleCount = shouldShowOverflow ? maxVisible - 1 : users.length;
  const visibleUsers = users.slice(0, visibleCount);
  const hiddenUsers = shouldShowOverflow ? users.slice(visibleCount) : [];

  const overflowTooltip = hiddenUsers.map((u) => u.userName).join('\n');

  return (
    <AssignList>
      {shouldShowOverflow && (
        <Tooltip content={overflowTooltip} placement={tooltipPlacement}>
          <TooltipWrapper>
            <AssignList.Avatar
              assignee={{
                id: 'overflow',
                name: `+${hiddenUsers.length}`,
                picture: '',
              }}
              noAbbreviate
            />
          </TooltipWrapper>
        </Tooltip>
      )}
      {visibleUsers.map((user) => (
        <Tooltip key={user.userId} content={user.userName} placement={tooltipPlacement}>
          <TooltipWrapper>
            <AssignList.Avatar
              assignee={{
                id: user.userId,
                name: user.userName,
                picture: user.userPicture,
              }}
            />
          </TooltipWrapper>
        </Tooltip>
      ))}
    </AssignList>
  );
};

const TooltipWrapper = styled.div({
  pointerEvents: 'auto',
});
